import React from 'react';

import { Divider, Row, Col } from 'antd';
import { getFullName } from 'utils/personUtils';
import { ProfileCorporatePrimaryContactInfoModel } from 'api/backofficeApiClient';

type Props = {
  primaryContact: ProfileCorporatePrimaryContactInfoModel;
};

export default function PrimaryContactCard(props: Props) {
  const { primaryContact } = props;

  const primaryContactName = getFullName(
    primaryContact?.firstName,
    primaryContact?.lastName,
  );

  return (
    <div className="divider-box">
      <div className="content-wrapper">
        <Row gutter={[4, 4]} className="titled-sheet">
          {!!primaryContactName && (
            <Col xs={24} md={12}>
              <div className="title">Primary contact:</div>
              <div>{primaryContactName}</div>
            </Col>
          )}

          {!!primaryContact?.title && (
            <Col xs={24} md={12}>
              <div className="title">Title:</div>
              <div>{primaryContact.title}</div>
            </Col>
          )}

          {!!primaryContact?.email && (
            <Col xs={24} md={12}>
              <div className="title">Email:</div>
              <div>{primaryContact.email}</div>
            </Col>
          )}

          {!!primaryContact?.phoneNumber && (
            <Col xs={24} md={12}>
              <div className="title">Phone number:</div>
              <div>{primaryContact.phoneNumber}</div>
            </Col>
          )}
        </Row>
      </div>
      <Divider className="card-divider no-margin" />
    </div>
  );
}
